import {
  FetchContributorsParams,
  FetchContributorsResponse,
  FetchProjectContributorsParams,
} from 'types/api/contributors';
import { baseApi } from './baseApi.ts';

export const contributorsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchContributors: builder.query<
      FetchContributorsResponse,
      FetchContributorsParams
    >({
      query: ({ project_id, page_no, limit = 20, workspace_id }) => ({
        url: '/user/contributors',
        params: { project_id, page_no, limit, workspace_id },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: 'Contributor' as const,
                id,
              })),
              { type: 'Contributor', id: 'LIST' },
            ]
          : [{ type: 'Contributor', id: 'LIST' }],
    }),
    fetchProjectContributors: builder.query<
      FetchContributorsResponse,
      FetchProjectContributorsParams
    >({
      query: ({ workspace_id, site_id }) => ({
        url: `/site/contributors/${site_id}`,
        params: { workspace_id },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: 'Contributor' as const,
                id,
              })),
              { type: 'Contributor', id: 'LIST' },
            ]
          : [{ type: 'Contributor', id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchContributorsQuery,
  useFetchProjectContributorsQuery,
  useLazyFetchContributorsQuery,
  useLazyFetchProjectContributorsQuery,
} = contributorsApi;
